import React, { useRef } from 'react';
import { useCountUp } from './hooks/useCountUp';

interface CountUpProps {
  value: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
  className?: string;
}

export const CountUp: React.FC<CountUpProps> = ({
  value,
  suffix = '',
  prefix = '',
  duration,
  className,
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const current = useCountUp({ ref, to: value, duration });
  const display = Math.round(current);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
};
